import { cn } from '@/ui/lib/utils';
import userIcon from '@/assets/icons/userIcon.svg';
import { Icon } from '@/ui/components/base/Icon/Icon';
import { heroesData } from '@/settings/heroesData';
import { sounds } from '@/utils/Sounds';
import './racerCard.css';

interface RacerCardProps {
    id: string;
    betsOn: number;
    multiplier: number;
    selected: boolean;
    onSelect: (id: string) => void;
}

export const RacerCard = ({ id, betsOn, multiplier, selected, onSelect }: RacerCardProps) => {
    return (
        <div
            className={cn('racer-card', selected && 'racer-card--selected')}
            onClick={() => {
                sounds.playFX('click');
                onSelect(id);
            }}
        >
            <img
                className="racer-card__thumbnail"
                src={`assets/images/${id}.png`}
                alt={`racer ${id}`}
            />

            <div className="racer-card__name">{heroesData[id].name || id}</div>

            <div className="racer-card__stats">
                <div className="racer-card__stat racer-card__stat--dark">{multiplier}x</div>
                <div className="racer-card__stat racer-card__stat--light">
                    <span key={betsOn} className="racer-card__stat-total-bets">
                        {betsOn}
                    </span>
                    <Icon className="racer-card__stat-icon" src={userIcon} alt="users" />
                </div>
            </div>
        </div>
    );
};
